import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Title,
  ValueContainer,
  SmallEstimate,
  Sub,
  PartnersContainer,
  PartnerWrapper,
} from '../survey.css';
import SignUpInput from '../signUpInput';
import Attom from '../../../../static/Attom.png';
import Collateral from '../../../../static/Collateral.png';
import Zillow from '../../../../static/Zillow.png';
import Partners from '../../../constants/partners';

const InitialValue = ({ vendor, value, blur }) => (
  <SmallEstimate blur={blur}>
    <img src={vendor} alt="Partner Logo" />
    <div className="val">{value}</div>
  </SmallEstimate>
);

InitialValue.propTypes = {
  vendor: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  blur: PropTypes.bool,
};

const Partner = ({ partner }) => (
  <PartnerWrapper>
    <img src={Partners[partner].logo} alt="partner" />
  </PartnerWrapper>
);

Partner.propTypes = {
  partner: PropTypes.string.isRequired,
};

class InitialEstimate extends Component {
  static propTypes = {
    partners: PropTypes.object,
    count: PropTypes.number,
  };

  static defaultProps = {
    count: 3,
  };

  state = {
    hasLoaded: false,
  };

  render() {
    const { hasEmail } = this.state;
    const { partners, count } = this.props;

    return (
      <Card>
        <Title>Initial Value Estimate</Title>

        <ValueContainer>
          <InitialValue vendor={Zillow} value="$500,000" />
          {count > 1 ? (
            <Fragment>
              <InitialValue
                vendor={Collateral}
                value="$530,000"
                blur={hasEmail}
              />
              <InitialValue vendor={Attom} value="$570,000" blur={!hasEmail} />
            </Fragment>
          ) : null}
        </ValueContainer>

        <Sub>Enter your email for more estimates</Sub>

        <SignUpInput delayReq />

        <Title medium underline>
          Local Partners
        </Title>

        <PartnersContainer>
          {count > 1 ? (
            partners &&
            Object.keys(partners).map((partner, i) => (
              <Partner key={i} partner={partner} />
            ))
          ) : (
            <Partner key={0} partner="HomeBay" />
          )}
        </PartnersContainer>
      </Card>
    );
  }
}

export default InitialEstimate;
